import React from 'react'
import '../styles/App.css'
import AudioCalls from '../components/audio-calls/AudioCalls'

function AudioCallsPage() {
  return (
    <div>
      <AudioCalls />
    </div>
  )
}

export default AudioCallsPage
